import FormViewForm from '@src/components/_forms/FormViewForm';
import {IProductModel} from '@src/@interfaces/models/Product/IProductModel';
import ProductTechProcessesLazyField from '@views/products/fields/ProductTechProcessesLazyField';
import StagesLazyField from '@views/products/fields/StagesLazyField';
import SetsOfVariablesLazyField from '@views/products/fields/SetsOfVariablesLazyField';

const customFields = {
    'techProcesses': {
        component: ProductTechProcessesLazyField,
    },
    '_tech-process-stages': {
        component: StagesLazyField,
    },
    '_tech-process-variables': {
        component: SetsOfVariablesLazyField,
    }
};

export default class ProductForm<Model extends IProductModel> extends FormViewForm<Model> {
    protected get customFields() {
        return customFields;
    }

    protected mutateModelFieldInitialValue(fieldName: string, modelValue: any): any {
        if (fieldName === 'techProcesses') {
            return this.getTechProcessesFieldInitialValue();
        }

        return super.mutateModelFieldInitialValue(fieldName, modelValue);
    }

    private getTechProcessesFieldInitialValue() {
        return this.props.model?.tech_processes?.map(item => {
            const variablesSets = item.variables_sets?.map(item => {
                const definedVariables = item.defined_variables?.map(item => {
                    return {...item, unit: item.unit_id};
                });
                const variableFormulas = item.variable_formulas;

                const newItem = {...item, definedVariables, variableFormulas};

                delete newItem.defined_variables;
                delete newItem.variable_formulas;

                return newItem;
            });

            const newItem = {...item, variablesSets};

            delete newItem.variables_sets;

            return newItem;
        });
    }
}
